// ReCharge Subscription Widget - Shadow DOM Style Injection
document.addEventListener('DOMContentLoaded', function() {
  // Wait for widget to load
  const observer = new MutationObserver(function(mutations) {
    const widget = document.querySelector('recharge-subscription-widget');
    
    if (widget && widget.shadowRoot) {
      // Widget loaded, inject styles
      injectStyles(widget.shadowRoot);
      observer.disconnect();
    }
  });

  // Observe DOM changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Check if widget is already loaded
  const existingWidget = document.querySelector('recharge-subscription-widget');
  if (existingWidget && existingWidget.shadowRoot) {
    injectStyles(existingWidget.shadowRoot);
  }
});

function injectStyles(shadowRoot, isNested = false) {
  // Log structure for debugging
  if (!isNested) {
    console.log('🔍 Shadow DOM structure:', shadowRoot);
    console.log('🔍 First element:', shadowRoot.firstElementChild);
  }
  
  const style = document.createElement('style');
  style.setAttribute('data-injected', 'true');
  style.textContent = `
        /* Purchase option */
        .rc-purchase-option {
            display: flex;
            flex-direction: column;
            padding: 20px 20px 20px 25px;
            border: none !important;
            background: rgba(226, 227, 227, 0.2);
        }


        .rc-purchase-option[rc-selected]{
            background: rgba(158, 50, 35, 0.1) !important;
        }
            

        /* Badge */
        .rc-purchase-option .rc-purchase-option__badge{
            position: unset;
            order: 2;
            padding: 0;
            background-color: transparent;
            padding-left: 30px;
            font-family: var(--font-family);
            font-weight: 600;
            font-size: 14px;
            line-height: 171%;
            letter-spacing: -0.02em;
            color: var(--core-palette-red);
        }

        /* Label */
        .rc-purchase-option .rc-purchase-option__label {
            order: 1;
            padding: 0;
        }

        .rc-purchase-option .rc-purchase-option__label .rc-purchase-option__prices{
            flex-direction: row-reverse;
            gap: 8px !important;
            align-items: center;

        }
        .rc-purchase-option .rc-purchase-option__label .rc-purchase-option__prices [part="rc-purchase-option__discounted-price"] {
            font-family: var(--font-family) !important;
            font-weight: 600 !important;
            font-size: 22px !important;
            line-height: 127% !important;
            letter-spacing: -0.03em !important;
            text-align: right !important;
            color: var(--core-palette-red) !important;
            display: flex;
            flex-direction: row;
        }

        .rc-purchase-option .rc-purchase-option__label .rc-purchase-option__prices [part="rc-purchase-option__discounted-price"] .price-dollars{
            font-family: var(--font-family) !important;
            font-weight: 600 !important;
            font-size: 22px !important;
            line-height: 127% !important;
            letter-spacing: -0.03em !important;
            text-align: right !important;
            color: var(--core-palette-red) !important;
        }


        .rc-purchase-option .rc-purchase-option__label .rc-purchase-option__prices [part="rc-purchase-option__price"]{
        font-family: var(--font-family) !important;
            font-weight: 600 !important;
            font-size: 22px !important;
            line-height: 127% !important;
            letter-spacing: -0.03em !important;
            text-align: right !important;
            color: var(--core-palette-red) !important;
            display: flex;
            flex-direction: row;
        }
        /* Cents smaller - using JavaScript for separation */
        .rc-purchase-option__prices [part="rc-purchase-option__discounted-price"],
        .rc-purchase-option__prices [part="rc-purchase-option__original-price"] {
            font-variant-numeric: tabular-nums;
        }

        .rc-purchase-option .rc-purchase-option__label .rc-purchase-option__prices [part="rc-purchase-option__original-price"] .price-dollars{
            font-family: var(--font-family) !important;
            font-weight: 500 !important;
            font-size: 18px !important;
            line-height: 133% !important;
            text-decoration: unset !important;
            text-align: right !important;
            color: var(--core-palette-pantone-cool-gray-7c);
            position: relative !important;
        }
            .rc-purchase-option .rc-purchase-option__label .rc-purchase-option__prices [part="rc-purchase-option__original-price"] {
            font-family: var(--font-family) !important;
            font-weight: 500 !important;
            font-size: 18px !important;
            line-height: 133% !important;
            text-decoration: unset !important;
            text-align: right !important;
            color: var(--core-palette-pantone-cool-gray-7c);
            position: relative !important;
            display: flex;
            flex-direction: row;
        }
        .rc-purchase-option .rc-purchase-option__label .rc-purchase-option__prices [part="rc-purchase-option__original-price"]:before{
            content: "";
            height: 0.5px;
            width: 100%;
            background-color: var(--core-palette-pantone-cool-gray-7c);
            position: absolute;
            left: 0;
            top: 47%;
            transform: translateY(-50%);

        }

        /* Sub-container */
        .rc-purchase-option .rc-purchase-option__sub-container{
            order: 3;
            padding: 0;
            padding-left: 30px;
            display: flex;
            flex-direction: column-reverse;
            gap: 15px;
        }

        /* Label */
        .rc-purchase-option__label{
            padding: 0 !important;
        }


        .rc-purchase-option__selector{
            font-family: var(--second-family);
            font-weight: 500 !important;
            font-size: 20px !important;
            line-height: 150%;
            letter-spacing: -0.06em;
            text-transform: uppercase;
            color: var(--core-palette-black);
            padding: 0 !important;
        }




        rc-selling-plans{
            margin-top: 19px !important;
        }
        .rc-plans-dropdown{
            display: flex !important;
            gap: 10px !important;

        }
        .rc-plans__label{
            font-family: var(--font-family);
            font-weight: 400 !important;
            font-size: 14px !important;
            line-height: 171%;
            letter-spacing: -0.02em;
            color: var(--core-palette-black);
        }
        .rc-benefits__list{
            
            display: flex !important;
            flex-direction: column !important;
            P{
                margin: 0 !important;
                padding-left: 30px !important;
                font-family: var(--font-family);
                font-weight: 300 !important;
                font-size: 14px !important;
                line-height: 171%;
                letter-spacing: -0.02em !important;
                color: var(--core-palette-black);
                position: relative !important;
                display: flex !important;
                padding-left: 30px !important;
                &:before{
                    content: "";
                    width: 18px;
                    height: 18px;
                    position: absolute;
                    left: 3px;
                    top: 3px;
                    background-image: url('data:image/svg+xml;utf8,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 9.57143H9.57143V13H8.42857V9.57143H5V8.42857H8.42857V5H9.57143V8.42857H13V9.57143Z" fill="%23261A1A"/></svg>');
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                }
            }
        }
        /* ========================================
           Radio button - red checkmark
           ======================================== */
        

        /* Checked state */
        
        .rc-checked-icon circle {
            stroke-width: 2px !important;
            overflow: visible !important;
        }

        .rc-checked-icon{
            width: 20px !important;
            --rc-widget-brand-color : var(--core-palette-red) !important;
            height: 20px !important;
            stroke-width: 2px !important;
            overflow: visible !important;
        }

        .rc-unchecked-icon{
            width: 20px !important;
            height: 20px !important;
            stroke-width: 2px !important;
            overflow: visible !important;
            --rc-widget-brand-color : var(--core-palette-red) !important;

        }
        .rc-unchecked-icon rect:first-child{
            stroke: var(--core-palette-red) !important;
            
        }
            .rc-unchecked-icon rect:last-child{
                stroke: none !important;
            }





        /* Hide any SVG arrows near dropdown */
        .rc-plans-dropdown svg,
        .rc-plans-dropdown [class*="arrow"],
        .rc-plans-dropdown [class*="chevron"],
        .rc-plans-dropdown [class*="icon"] {
            display: none !important;
            visibility: hidden !important;
        }

        .rc-plans-dropdown__select{
            padding: 4px 10px !important;
            padding-right: 30px !important;
            font-family: var(--font-family);
            font-weight: 400 !important;
            font-size: 14px !important;
            line-height: 100% !important;
            letter-spacing: -0.02em !important;
            color: var(--core-palette-black) !important;
            position: relative !important;
            
            /* Remove default arrow */
            appearance: none !important;
            -webkit-appearance: none !important;
            -moz-appearance: none !important;
            
            /* Add custom arrow */
            background-image: url('data:image/svg+xml;utf8,<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="%23000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') !important;
            background-repeat: no-repeat !important;
            background-position: right 10px center !important;
            background-size: 10px 6px !important;
            
            &:focus-visible{
                outline: 0;
                box-shadow: none !important;
            }
        }
        /* Note: RC-PLANS-DROPDOWN styles are injected separately into its Shadow DOM */
        
  `;
  
  // Insert styles at the beginning of Shadow DOM
  if (shadowRoot.firstChild) {
    shadowRoot.insertBefore(style, shadowRoot.firstChild);
  } else {
    shadowRoot.appendChild(style);
  }
  
  if (!isNested) {
    console.log('✅ ReCharge widget styles injected successfully');
    console.log('📋 Applied styles:', style.textContent.substring(0, 200) + '...');
  }

  // Find nested Shadow DOMs and inject styles into them
  const processNestedShadows = () => {
    const nestedShadowElements = shadowRoot.querySelectorAll('*');
    nestedShadowElements.forEach(el => {
      if (el.shadowRoot && !el.shadowRoot.querySelector('style[data-injected]')) {
        console.log('🔍 Found nested shadow root in:', el.tagName, el);
        
        // Inject special styles for rc-plans-dropdown
        if (el.tagName.toLowerCase() === 'rc-plans-dropdown') {
          injectDropdownStyles(el.shadowRoot);
        } else {
          injectStyles(el.shadowRoot, true);
        }
      }
    });
  };

  // Initial processing
  setTimeout(() => {
    processNestedShadows();
  }, 100);

  // Repeated processing with longer delay (for dynamic elements)
  setTimeout(() => {
    processNestedShadows();

    // Format prices - make cents smaller (with delay for nested Shadow DOMs)
    if (!isNested) {
      formatPricesWithSmallCents(shadowRoot);
      // Observe dynamic changes
      observePriceChanges(shadowRoot);
      
      // Observe appearance of new nested Shadow DOMs
      const shadowObserver = new MutationObserver(() => {
        processNestedShadows();
      });
      
      shadowObserver.observe(shadowRoot, {
        childList: true,
        subtree: true
      });

      // Also track clicks (for dropdown that appears on click)
      shadowRoot.addEventListener('click', () => {
        setTimeout(() => {
          processNestedShadows();
        }, 50);
      }, true);
    }
  }, isNested ? 100 : 500);
}

// Special styles for RC-PLANS-DROPDOWN (nested Shadow DOM)
function injectDropdownStyles(shadowRoot) {
  console.log('📋 Dropdown Shadow DOM structure:', shadowRoot);
  console.log('📋 Dropdown children:', shadowRoot.children);
  console.log('📋 Dropdown all elements:', shadowRoot.querySelectorAll('*'));
  
  const style = document.createElement('style');
  style.setAttribute('data-injected', 'true');
  style.textContent = `
    .rc-plans-dropdown{
        display: flex;
    }

    
  `;

  if (shadowRoot.firstChild) {
    shadowRoot.insertBefore(style, shadowRoot.firstChild);
  } else {
    shadowRoot.appendChild(style);
  }

  console.log('✅ Dropdown styles injected');
}

// Recursive search through all Shadow DOMs
function findAllShadowRoots(root, callback) {
  // Apply callback to current root
  callback(root);
  
  // Find all elements with shadow root
  const allElements = root.querySelectorAll('*');
  allElements.forEach(el => {
    if (el.shadowRoot) {
      console.log('🔍 Found nested shadow root in:', el.tagName);
      findAllShadowRoots(el.shadowRoot, callback);
    }
  });
}

function formatPricesWithSmallCents(shadowRoot) {
  // Recursively format prices in all Shadow DOMs
  findAllShadowRoots(shadowRoot, (root) => {
    // Find all price elements in current root
    const priceElements = root.querySelectorAll(
      '[part="rc-purchase-option__discounted-price"], [part="rc-purchase-option__original-price"], [part="rc-purchase-option__price"]'
    );

    priceElements.forEach(priceEl => {
      // Skip if already formatted
      if (priceEl.querySelector('.price-dollars')) return;
      
      const originalText = priceEl.textContent.trim();
      console.log('🔍 Original price text:', originalText);
      
      // Search pattern: $XX.XX or $ XX.XX (with possible space)
      const match = originalText.match(/(\$\s*\d+\.)(\d{2})/);
      
      if (match) {
        const dollarsWithDot = match[1]; // $54. or $ 54. (with dot)
        const centsOnly = match[2];      // 00 (without dot)
        
        console.log('✅ Matched:', { dollarsWithDot, centsOnly });
        
        // Create HTML with different sizes
        priceEl.innerHTML = `
          <span class="price-dollars" style="font-size: 22px;">${dollarsWithDot}</span><span class="price-cents" style="margin-top: 2px; font-size: 0.6em; vertical-align: top; line-height: 1.4;">${centsOnly}</span>
        `;
      } else {
        console.warn('❌ No match for:', originalText);
      }
    });
  });
}

// Observe dynamic changes (for dropdown, etc.)
function observePriceChanges(shadowRoot) {
  const observer = new MutationObserver(() => {
    console.log('🔄 Price changed, reformatting...');
    formatPricesWithSmallCents(shadowRoot);
  });

  findAllShadowRoots(shadowRoot, (root) => {
    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  });
}

